if (typeof window !== "undefined") {
  if (typeof window.$RefreshReg$ === "undefined") {
    window.$RefreshReg$ = () => {};
  }
  if (typeof window.$RefreshSig$ === "undefined") {
    window.$RefreshSig$ = () => (type) => type;
  }
}

import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "./context/ThemeContext";
import "./index.css";
import App from "./App";
import { registerServiceWorker } from "./lib/pwa";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);

registerServiceWorker();
